import { useIsDisabledFeaturedOnTelegram } from 'hooks/useTelegram'
import { useMemo, useState } from 'react'
import { useDisplayCommitment } from 'state/app/hooks'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { ICommitmentsControl } from '../types'

const useCommitmentVisibility = (paymentPage: PaymentPageEnums): ICommitmentsControl => {
  const [isShowCommitment, setIsDetailVisible] = useState(false)
  const isCommitmentFromSystemSetting = useDisplayCommitment()
  const isDisabledFeaturedOnTelegram = useIsDisabledFeaturedOnTelegram()

  const isShowCommitmentBar = useMemo(() => {
    return (
      paymentPage === PaymentPageEnums.Deposit &&
      !isDisabledFeaturedOnTelegram &&
      isCommitmentFromSystemSetting &&
      !isShowCommitment
    )
  }, [paymentPage, isDisabledFeaturedOnTelegram, isCommitmentFromSystemSetting, isShowCommitment])

  const toggleCommitment = () => {
    setIsDetailVisible((prev) => !prev)
  }

  return {
    isShowCommitmentBar,
    isShowCommitment,
    toggleCommitment,
  }
}

export default useCommitmentVisibility
